<template>
    <div id="listMileageUpload">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Mileage Upload List</div>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                    </div>    
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <data-table-filter-config :moduleName="'mileageUploadList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Current batch {{batchNum}} is processing please wait!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'mileageUploadList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listMileageTable"
                                    mode="remote"
                                    @on-page-change="onPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-cell-click="onRowClick"
                                    :totalRows="totalRecords"
                                    @on-select-all="onSelectAll"
                                    title="Mileage Upload"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :paginate="true"
                                    :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }"
                                >

                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>

                                <div slot="selected-row-actions">
                                    <button v-if="canDeleteUpload" id="deleteUploadBtn" v-on:click.prevent="deleteMileageUpload" class="btn btn-danger">Delete</button>
                                </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                                
                        </section>
                        <div class="modal fade mileage-upload-modal" id="mileage-upload-modal" ref="mileage-upload-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="mileage-upload-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                                    <input id="mileageUploadFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_error}}</div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file </label>
                                                    <a href="javascript:void(0)" v-on:click="downloadSample('sample')"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                            </div>
                                        </form>

                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButton" v-on:click="importMileageUpload()"> <i class="fp-import"> </i> Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 

                        <div class="modal fade mileage-upload-error-modal" id="mileage-upload-error-modal" ref="mileage-upload-error-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="mileage-upload-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Download File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> {{errorMessage}} </label><br>
                                                    <a href="javascript:void(0)" v-on:click="downloadSample('error')"> <i class="fp-text-document fp-blue"></i> Click Here </a>
                                                </div>
                                            </div>
                                        </form>

                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>        
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>    
</template>
<script>
import Vue from 'vue';
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);
import EventBus from "./event-bus";
let msgServer;
export default {
    name: "MileageUploadList",
    metaInfo: {
        title: "Mileage Upload List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({ 
        firstLoad:0,
        userColumns:[],
        columns: [
            {
                label: 'Batch',
                field: 'batch',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Batch", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }

            },
            {
                label: 'Upload Date',
                field: 'upload_date',
                fpFieldType:"date",
                html: false,
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }

            },
            {
                label: 'Records',
                field: 'records',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Records", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Created By',
                field: 'created_by',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }

            },
            {
                label: 'Created At',
                field: 'created_at',
                fpFieldType:"date",
                html: false,
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "created_at", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        permissions:[],
        cantAccessPage:'',
        action:'list',
        selectedFile:"",
        batchId:'',
        batchProcess:false,
        batchNum:'',
        file:'',
        import_error:'',
        fileName:'',
        canDeleteUpload:false,
        batchError:false,
        batchErrorMsg:"",
        errorMessage:'',
        errorFile:'',
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_mileage_upload') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'delete_mileage_upload') {
                    self.canDeleteUpload = true;
                }
            });
            if (self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    created: function() {
        this.serverParams.sort = {field:"created_at",type:"desc"};
    },
    mounted: function () {

        var self = this;
        self.getPermissions();


    },
    methods: {
        cancelAll: function (cancelAll) {
            this.$refs.listMileageTable.unselectAllInternal();
        },
        checkBatchStatus:function(){
            var self =  this;
            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.batchProcess = false;
                        self.loadList();
                        sse.close();
                    }else if (data.status == "2") {
                        self.batchProcess = false;
                        self.batchError = true;
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });

        },
        loadList: function(){

            var data = this.$refs['listMileageTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listMileageTable'].selectedRows[i].batch)
            }

            var self = this;
            self.loading =  true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/mileage-upload/list",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",

                data:{
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: this.serverParams.columnFilters,
                    sort:self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    selectedRows:use,
                    action:self.action,
                },
                success: function (data) {
                    self.loading =  false;

                    if (data.status == "success") {
                        if (self.action == "delete") {
                            self.action = "list";

                            var msg = "";

                            msg = data.content+" records have been deleted";

                            self.$swal('',msg,data.status);
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.generateStatusCodeMessage(jqXHR, false, 'mileage-upload-list')
                }
            });
        },

        openModal: function(){
            var self = this;
            if (self.batchProcess){
                self.$swal('','Previous batch already runnig','info');
                return;
            }
            self.selectedFile = "";
            $("#mileageUploadFile").val('');
            self.import_error = '';
            self.generateExcelSample();
            $('#mileage-upload-modal').modal('show');
        },
        onFileChanged(event) {
            const file = event.target.files[0];
            var self = this;
            self.selectedFile = file;
            self.import_error = '';
        },
        importMileageUpload() {
            var self = this;
            var self = this;

            self.import_error = "";
            if( self.selectedFile == "" || self.selectedFile == null){
                self.import_error = "Please Select Excel File.";
                return;
            }
            var fileExtension = ['xls', 'xlsx'];
            if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                return;
            }

            var formData = new FormData();
            formData.append('myFile', self.selectedFile);

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/mileage-upload/import",
                type: "POST",
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.code == 201){
                        self.errorMessage = data.message;
                        self.errorFile = data.file.web;
                        $('#mileage-upload-modal').modal('hide');
                        $('#mileage-upload-error-modal').modal('show');
                        return;
                    }
                    if (data.batch_id){
                        self.batchProcess = true;
                        self.batchId = data.batch_id;
                        self.batchNum = data.batch;
                        self.checkBatchStatus();
                        $('#mileage-upload-modal').modal('hide');
                    }
                    self.loadList();

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    $('#importButton').text('Import');
                    $('#importButton').prop('disabled',false);
                    $('#cancelButton').prop('disabled',false);
                    self.generateStatusCodeMessage(jqXHR,true,'mileage-upload-import-error')
                }
            });
        },
        generateExcelSample:function(){
            var self = this;

            $.ajax({
                url:
                process.env.ROOT_API +
                "/mileage-upload/generate",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,

                success: function(data) {
                    self.loading = false;
                    self.fileName = data.content.file;
                    self.file = data.content.web;

                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'mileage-upload-generate')

                }
            });
        },
        downloadSample(flag){
            var self = this;
            // alert(self.file);
            if (flag == 'error'){
                var docPath = self.errorFile;
            }else{
                var docPath = self.file;
            }
            var save = document.createElement('a');
            save.href = docPath;
            save.download = docPath;
            save.target = '_blank';
            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
        },
        onRowClick(params,event) {

            var self = this;
            self.$router.push('/mileage-upload-detail/list/'+params.row.batch);

        },
        deleteMileageUpload() {
            var self = this;            
            self.$swal({
                title: 'Are you sure that you want to delete this Mileage Upload?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    self.action = "delete";
                    self.loadList();
                } else {
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/MileageUploadList.vue